<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate';
</script>

<template>
  <!-- Neutral content-area placeholder: deliberately does not promise a specific
       structure (accordions, info box, forms), so resolving to any of them reads
       as a fill rather than a layout jump. -->
  <div class="animate-pulse" aria-hidden="true">
    <span class="sr-only">{{ $t('ibe.common.loading', 'Loading...') }}</span>
    <div class="h-40 w-full bg-actions-tertiary rounded-xl"></div>
  </div>
</template>
